/**
 * Primary public “shelf” for a person — browse filter + portrait color.
 * Specific crafts go in PersonOccupationEnum.
 */
export enum PersonDomainEnum {
    MUSIC = 'music',
    LITERATURE = 'literature',
    VISUAL_ART = 'visual_art',
    POLITICS = 'politics',
    ARCHITECTURE = 'architecture',
    ACTING = 'acting',
    SCIENCE = 'science',
    SPORT = 'sport',
    FILM = 'film',
}
